import { AUDIO, IN_PERSON, TEXT, VIDEO, SLIDES } from "../../constants";
import lessonIconTemplate from "./lesson_icon.html";

class LessonIconController {
    /* @ngInject */
    constructor() {
        this.VIDEO = VIDEO;
        this.AUDIO = AUDIO;
        this.TEXT = TEXT;
        this.IN_PERSON = IN_PERSON;
        this.SLIDES = SLIDES;
    }
}
export default {
    bindings: { category: "<" },
    name: "lessonIcon",
    controller: LessonIconController,
    template: lessonIconTemplate,
};
